import { Alert, Typography } from "@material-tailwind/react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/solid";
import { useSelector, useDispatch } from "react-redux";
import { closeError, closemodalError } from "../redux/actions/app";
import { useEffect } from "react";
import { CheckCircleIcon } from "@heroicons/react/24/outline";
const AlertView = () => {
  const app = useSelector((state) => state.app);
  const dispatch = useDispatch();

  useEffect(() => {
    const timer = setTimeout(() => {
      if (app.error) {
        dispatch(closeError());
      } else {
        dispatch(closemodalError());
      }
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  const message1 = app?.error?.message;

  return (
    <div className="top-0 absolute w-full flex justify-center pt-4 z-[9999]">
      <Alert
        color={app.error.color ? app.error.color : "red"}
        open={app.error || app.modal_error ? true : false}
        className="max-w-screen-md w-[50%]"
        icon={
          app.error.color === "green" ? (
            <CheckCircleIcon className="mt-px h-6 w-6" />
          ) : (
            <ExclamationTriangleIcon className="mt-px h-6 w-6" />
          )
        }
        onClose={() => dispatch(closeError())}
      >
        <Typography variant="h5" color="white">
          {app.error ? app.error.type : app.modal_error.type}
        </Typography>

        {Array.isArray(message1) ? (
          <>
            {message1.map((name) => (
              <li>{name}</li>
            ))}
          </>
        ) : (
          <>
            <Typography color="white" className="mt-2 font-normal">
              {app.error.message}
            </Typography>
          </>
        )}
      </Alert>
    </div>
  );
};

export default AlertView;
